@file:OptIn(InternalResourceApi::class)

package gero.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/gero.composeapp.generated.resources/"

@delegate:ResourceContentHash(-1_390_367_684)
internal val Res.drawable.D49: DrawableResource by lazy {
      DrawableResource("drawable:D49", setOf(
        ResourceItem(setOf(), "${MD}drawable/D49.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(148_200_914)
internal val Res.drawable.D5: DrawableResource by lazy {
      DrawableResource("drawable:D5", setOf(
        ResourceItem(setOf(), "${MD}drawable/D5.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_694_436_400)
internal val Res.drawable.D50: DrawableResource by lazy {
      DrawableResource("drawable:D50", setOf(
        ResourceItem(setOf(), "${MD}drawable/D50.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_423_327_527)
internal val Res.drawable.D50A: DrawableResource by lazy {
      DrawableResource("drawable:D50A", setOf(
        ResourceItem(setOf(), "${MD}drawable/D50A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_755_377_881)
internal val Res.drawable.D50B: DrawableResource by lazy {
      DrawableResource("drawable:D50B", setOf(
        ResourceItem(setOf(), "${MD}drawable/D50B.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_869_589_963)
internal val Res.drawable.D50C: DrawableResource by lazy {
      DrawableResource("drawable:D50C", setOf(
        ResourceItem(setOf(), "${MD}drawable/D50C.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_202_786_893)
internal val Res.drawable.D50D: DrawableResource by lazy {
      DrawableResource("drawable:D50D", setOf(
        ResourceItem(setOf(), "${MD}drawable/D50D.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_989_653_846)
internal val Res.drawable.D50E: DrawableResource by lazy {
      DrawableResource("drawable:D50E", setOf(
        ResourceItem(setOf(), "${MD}drawable/D50E.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_040_148_260)
internal val Res.drawable.D50F: DrawableResource by lazy {
      DrawableResource("drawable:D50F", setOf(
        ResourceItem(setOf(), "${MD}drawable/D50F.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_127_825_456)
internal val Res.drawable.D50G: DrawableResource by lazy {
      DrawableResource("drawable:D50G", setOf(
        ResourceItem(setOf(), "${MD}drawable/D50G.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_280_031_600)
internal val Res.drawable.D50H: DrawableResource by lazy {
      DrawableResource("drawable:D50H", setOf(
        ResourceItem(setOf(), "${MD}drawable/D50H.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-689_466_172)
internal val Res.drawable.D50I: DrawableResource by lazy {
      DrawableResource("drawable:D50I", setOf(
        ResourceItem(setOf(), "${MD}drawable/D50I.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_499_789_593)
internal val Res.drawable.D51: DrawableResource by lazy {
      DrawableResource("drawable:D51", setOf(
        ResourceItem(setOf(), "${MD}drawable/D51.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_581_332_165)
internal val Res.drawable.D52: DrawableResource by lazy {
      DrawableResource("drawable:D52", setOf(
        ResourceItem(setOf(), "${MD}drawable/D52.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_753_147_307)
internal val Res.drawable.D52A: DrawableResource by lazy {
      DrawableResource("drawable:D52A", setOf(
        ResourceItem(setOf(), "${MD}drawable/D52A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-350_579_606)
internal val Res.drawable.D53: DrawableResource by lazy {
      DrawableResource("drawable:D53", setOf(
        ResourceItem(setOf(), "${MD}drawable/D53.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-258_818_233)
internal val Res.drawable.D54: DrawableResource by lazy {
      DrawableResource("drawable:D54", setOf(
        ResourceItem(setOf(), "${MD}drawable/D54.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_032_287_545)
internal val Res.drawable.D54A: DrawableResource by lazy {
      DrawableResource("drawable:D54A", setOf(
        ResourceItem(setOf(), "${MD}drawable/D54A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_537_764_576)
internal val Res.drawable.D55: DrawableResource by lazy {
      DrawableResource("drawable:D55", setOf(
        ResourceItem(setOf(), "${MD}drawable/D55.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(236_016_011)
internal val Res.drawable.D56: DrawableResource by lazy {
      DrawableResource("drawable:D56", setOf(
        ResourceItem(setOf(), "${MD}drawable/D56.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-500_777_874)
internal val Res.drawable.D57: DrawableResource by lazy {
      DrawableResource("drawable:D57", setOf(
        ResourceItem(setOf(), "${MD}drawable/D57.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_479_841_341)
internal val Res.drawable.D58: DrawableResource by lazy {
      DrawableResource("drawable:D58", setOf(
        ResourceItem(setOf(), "${MD}drawable/D58.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_962_137_375)
internal val Res.drawable.D59: DrawableResource by lazy {
      DrawableResource("drawable:D59", setOf(
        ResourceItem(setOf(), "${MD}drawable/D59.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_122_443_545)
internal val Res.drawable.D6: DrawableResource by lazy {
      DrawableResource("drawable:D6", setOf(
        ResourceItem(setOf(), "${MD}drawable/D6.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(732_638_624)
internal val Res.drawable.D60: DrawableResource by lazy {
      DrawableResource("drawable:D60", setOf(
        ResourceItem(setOf(), "${MD}drawable/D60.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(706_664_578)
internal val Res.drawable.D61: DrawableResource by lazy {
      DrawableResource("drawable:D61", setOf(
        ResourceItem(setOf(), "${MD}drawable/D61.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_051_111_231)
internal val Res.drawable.D62: DrawableResource by lazy {
      DrawableResource("drawable:D62", setOf(
        ResourceItem(setOf(), "${MD}drawable/D62.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_262_352_914)
internal val Res.drawable.D63: DrawableResource by lazy {
      DrawableResource("drawable:D63", setOf(
        ResourceItem(setOf(), "${MD}drawable/D63.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-40_876_511)
internal val Res.drawable.D64: DrawableResource by lazy {
      DrawableResource("drawable:D64", setOf(
        ResourceItem(setOf(), "${MD}drawable/D64.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_408_917_312)
internal val Res.drawable.D65: DrawableResource by lazy {
      DrawableResource("drawable:D65", setOf(
        ResourceItem(setOf(), "${MD}drawable/D65.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_048_192_116)
internal val Res.drawable.D66: DrawableResource by lazy {
      DrawableResource("drawable:D66", setOf(
        ResourceItem(setOf(), "${MD}drawable/D66.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_052_374_271)
internal val Res.drawable.D67: DrawableResource by lazy {
      DrawableResource("drawable:D67", setOf(
        ResourceItem(setOf(), "${MD}drawable/D67.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_601_933_041)
internal val Res.drawable.D67A: DrawableResource by lazy {
      DrawableResource("drawable:D67A", setOf(
        ResourceItem(setOf(), "${MD}drawable/D67A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_138_059_479)
internal val Res.drawable.D67B: DrawableResource by lazy {
      DrawableResource("drawable:D67B", setOf(
        ResourceItem(setOf(), "${MD}drawable/D67B.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-650_639_231)
internal val Res.drawable.D67C: DrawableResource by lazy {
      DrawableResource("drawable:D67C", setOf(
        ResourceItem(setOf(), "${MD}drawable/D67C.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(356_218_498)
internal val Res.drawable.D67D: DrawableResource by lazy {
      DrawableResource("drawable:D67D", setOf(
        ResourceItem(setOf(), "${MD}drawable/D67D.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-646_850_928)
internal val Res.drawable.D67E: DrawableResource by lazy {
      DrawableResource("drawable:D67E", setOf(
        ResourceItem(setOf(), "${MD}drawable/D67E.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_906_931_196)
internal val Res.drawable.D67F: DrawableResource by lazy {
      DrawableResource("drawable:D67F", setOf(
        ResourceItem(setOf(), "${MD}drawable/D67F.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_847_900_966)
internal val Res.drawable.D67G: DrawableResource by lazy {
      DrawableResource("drawable:D67G", setOf(
        ResourceItem(setOf(), "${MD}drawable/D67G.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_002_769_459)
internal val Res.drawable.D67H: DrawableResource by lazy {
      DrawableResource("drawable:D67H", setOf(
        ResourceItem(setOf(), "${MD}drawable/D67H.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_033_709_907)
internal val Res.drawable.D7: DrawableResource by lazy {
      DrawableResource("drawable:D7", setOf(
        ResourceItem(setOf(), "${MD}drawable/D7.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-215_508_753)
internal val Res.drawable.D8: DrawableResource by lazy {
      DrawableResource("drawable:D8", setOf(
        ResourceItem(setOf(), "${MD}drawable/D8.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_069_305_708)
internal val Res.drawable.D8A: DrawableResource by lazy {
      DrawableResource("drawable:D8A", setOf(
        ResourceItem(setOf(), "${MD}drawable/D8A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-743_372_638)
internal val Res.drawable.D9: DrawableResource by lazy {
      DrawableResource("drawable:D9", setOf(
        ResourceItem(setOf(), "${MD}drawable/D9.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_026_138_651)
internal val Res.drawable.E1: DrawableResource by lazy {
      DrawableResource("drawable:E1", setOf(
        ResourceItem(setOf(), "${MD}drawable/E1.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(799_913_125)
internal val Res.drawable.E10: DrawableResource by lazy {
      DrawableResource("drawable:E10", setOf(
        ResourceItem(setOf(), "${MD}drawable/E10.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_422_013_862)
internal val Res.drawable.E11: DrawableResource by lazy {
      DrawableResource("drawable:E11", setOf(
        ResourceItem(setOf(), "${MD}drawable/E11.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_832_323_558)
internal val Res.drawable.E12: DrawableResource by lazy {
      DrawableResource("drawable:E12", setOf(
        ResourceItem(setOf(), "${MD}drawable/E12.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(38_370_401)
internal val Res.drawable.E13: DrawableResource by lazy {
      DrawableResource("drawable:E13", setOf(
        ResourceItem(setOf(), "${MD}drawable/E13.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_433_733_485)
internal val Res.drawable.E14: DrawableResource by lazy {
      DrawableResource("drawable:E14", setOf(
        ResourceItem(setOf(), "${MD}drawable/E14.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(526_875_467)
internal val Res.drawable.E15: DrawableResource by lazy {
      DrawableResource("drawable:E15", setOf(
        ResourceItem(setOf(), "${MD}drawable/E15.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_124_274)
internal val Res.drawable.E16: DrawableResource by lazy {
      DrawableResource("drawable:E16", setOf(
        ResourceItem(setOf(), "${MD}drawable/E16.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-628_898_876)
internal val Res.drawable.E16A: DrawableResource by lazy {
      DrawableResource("drawable:E16A", setOf(
        ResourceItem(setOf(), "${MD}drawable/E16A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(137_634_454)
internal val Res.drawable.E17: DrawableResource by lazy {
      DrawableResource("drawable:E17", setOf(
        ResourceItem(setOf(), "${MD}drawable/E17.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(502_925_060)
internal val Res.drawable.E17A: DrawableResource by lazy {
      DrawableResource("drawable:E17A", setOf(
        ResourceItem(setOf(), "${MD}drawable/E17A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(407_229_732)
internal val Res.drawable.E18: DrawableResource by lazy {
      DrawableResource("drawable:E18", setOf(
        ResourceItem(setOf(), "${MD}drawable/E18.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-365_360_847)
internal val Res.drawable.E19: DrawableResource by lazy {
      DrawableResource("drawable:E19", setOf(
        ResourceItem(setOf(), "${MD}drawable/E19.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_475_583_064)
internal val Res.drawable.E2: DrawableResource by lazy {
      DrawableResource("drawable:E2", setOf(
        ResourceItem(setOf(), "${MD}drawable/E2.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_073_248_771)
internal val Res.drawable.E20: DrawableResource by lazy {
      DrawableResource("drawable:E20", setOf(
        ResourceItem(setOf(), "${MD}drawable/E20.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-870_277_847)
internal val Res.drawable.E20A: DrawableResource by lazy {
      DrawableResource("drawable:E20A", setOf(
        ResourceItem(setOf(), "${MD}drawable/E20A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-171_811_813)
internal val Res.drawable.E21: DrawableResource by lazy {
      DrawableResource("drawable:E21", setOf(
        ResourceItem(setOf(), "${MD}drawable/E21.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_064_563_161)
internal val Res.drawable.E22: DrawableResource by lazy {
      DrawableResource("drawable:E22", setOf(
        ResourceItem(setOf(), "${MD}drawable/E22.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-171_561_423)
internal val Res.drawable.E23: DrawableResource by lazy {
      DrawableResource("drawable:E23", setOf(
        ResourceItem(setOf(), "${MD}drawable/E23.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_232_779_421)
internal val Res.drawable.E24: DrawableResource by lazy {
      DrawableResource("drawable:E24", setOf(
        ResourceItem(setOf(), "${MD}drawable/E24.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(255_287_270)
internal val Res.drawable.E25: DrawableResource by lazy {
      DrawableResource("drawable:E25", setOf(
        ResourceItem(setOf(), "${MD}drawable/E25.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-584_539_667)
internal val Res.drawable.E26: DrawableResource by lazy {
      DrawableResource("drawable:E26", setOf(
        ResourceItem(setOf(), "${MD}drawable/E26.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-538_872_108)
internal val Res.drawable.E27: DrawableResource by lazy {
      DrawableResource("drawable:E27", setOf(
        ResourceItem(setOf(), "${MD}drawable/E27.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-414_179_113)
internal val Res.drawable.E28: DrawableResource by lazy {
      DrawableResource("drawable:E28", setOf(
        ResourceItem(setOf(), "${MD}drawable/E28.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_832_785_158)
internal val Res.drawable.E28A: DrawableResource by lazy {
      DrawableResource("drawable:E28A", setOf(
        ResourceItem(setOf(), "${MD}drawable/E28A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_450_326_625)
internal val Res.drawable.E29: DrawableResource by lazy {
      DrawableResource("drawable:E29", setOf(
        ResourceItem(setOf(), "${MD}drawable/E29.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_020_595_073)
internal val Res.drawable.E3: DrawableResource by lazy {
      DrawableResource("drawable:E3", setOf(
        ResourceItem(setOf(), "${MD}drawable/E3.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_911_264_224)
internal val Res.drawable.E30: DrawableResource by lazy {
      DrawableResource("drawable:E30", setOf(
        ResourceItem(setOf(), "${MD}drawable/E30.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(837_754_873)
internal val Res.drawable.E31: DrawableResource by lazy {
      DrawableResource("drawable:E31", setOf(
        ResourceItem(setOf(), "${MD}drawable/E31.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(711_151_639)
internal val Res.drawable.E32: DrawableResource by lazy {
      DrawableResource("drawable:E32", setOf(
        ResourceItem(setOf(), "${MD}drawable/E32.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-406_667_706)
internal val Res.drawable.E33: DrawableResource by lazy {
      DrawableResource("drawable:E33", setOf(
        ResourceItem(setOf(), "${MD}drawable/E33.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_945_143_488)
internal val Res.drawable.E34: DrawableResource by lazy {
      DrawableResource("drawable:E34", setOf(
        ResourceItem(setOf(), "${MD}drawable/E34.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(288_640_544)
internal val Res.drawable.E34A: DrawableResource by lazy {
      DrawableResource("drawable:E34A", setOf(
        ResourceItem(setOf(), "${MD}drawable/E34A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-109_734_888)
internal val Res.drawable.E36: DrawableResource by lazy {
      DrawableResource("drawable:E36", setOf(
        ResourceItem(setOf(), "${MD}drawable/E36.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(416_877_017)
internal val Res.drawable.E37: DrawableResource by lazy {
      DrawableResource("drawable:E37", setOf(
        ResourceItem(setOf(), "${MD}drawable/E37.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-822_697_776)
internal val Res.drawable.E38: DrawableResource by lazy {
      DrawableResource("drawable:E38", setOf(
        ResourceItem(setOf(), "${MD}drawable/E38.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(687_163_436)
internal val Res.drawable.E4: DrawableResource by lazy {
      DrawableResource("drawable:E4", setOf(
        ResourceItem(setOf(), "${MD}drawable/E4.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_901_687_667)
internal val Res.drawable.E5: DrawableResource by lazy {
      DrawableResource("drawable:E5", setOf(
        ResourceItem(setOf(), "${MD}drawable/E5.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(958_075_386)
internal val Res.drawable.E6: DrawableResource by lazy {
      DrawableResource("drawable:E6", setOf(
        ResourceItem(setOf(), "${MD}drawable/E6.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(95_851_915)
internal val Res.drawable.E7: DrawableResource by lazy {
      DrawableResource("drawable:E7", setOf(
        ResourceItem(setOf(), "${MD}drawable/E7.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(155_975_062)
internal val Res.drawable.E8: DrawableResource by lazy {
      DrawableResource("drawable:E8", setOf(
        ResourceItem(setOf(), "${MD}drawable/E8.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_240_885_232)
internal val Res.drawable.E8A: DrawableResource by lazy {
      DrawableResource("drawable:E8A", setOf(
        ResourceItem(setOf(), "${MD}drawable/E8A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_925_600_667)
internal val Res.drawable.E9: DrawableResource by lazy {
      DrawableResource("drawable:E9", setOf(
        ResourceItem(setOf(), "${MD}drawable/E9.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-35_059_971)
internal val Res.drawable.E9A: DrawableResource by lazy {
      DrawableResource("drawable:E9A", setOf(
        ResourceItem(setOf(), "${MD}drawable/E9A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_113_751_032)
internal val Res.drawable.F1: DrawableResource by lazy {
      DrawableResource("drawable:F1", setOf(
        ResourceItem(setOf(), "${MD}drawable/F1.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-211_463_823)
internal val Res.drawable.F10: DrawableResource by lazy {
      DrawableResource("drawable:F10", setOf(
        ResourceItem(setOf(), "${MD}drawable/F10.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-899_545_406)
internal val Res.drawable.F11: DrawableResource by lazy {
      DrawableResource("drawable:F11", setOf(
        ResourceItem(setOf(), "${MD}drawable/F11.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_583_268_056)
internal val Res.drawable.F12: DrawableResource by lazy {
      DrawableResource("drawable:F12", setOf(
        ResourceItem(setOf(), "${MD}drawable/F12.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_782_833_408)
internal val Res.drawable.F13: DrawableResource by lazy {
      DrawableResource("drawable:F13", setOf(
        ResourceItem(setOf(), "${MD}drawable/F13.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_560_290_274)
internal val Res.drawable.F13A: DrawableResource by lazy {
      DrawableResource("drawable:F13A", setOf(
        ResourceItem(setOf(), "${MD}drawable/F13A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_014_257_003)
internal val Res.drawable.F14: DrawableResource by lazy {
      DrawableResource("drawable:F14", setOf(
        ResourceItem(setOf(), "${MD}drawable/F14.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-98_081_884)
internal val Res.drawable.F15: DrawableResource by lazy {
      DrawableResource("drawable:F15", setOf(
        ResourceItem(setOf(), "${MD}drawable/F15.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-431_908_258)
internal val Res.drawable.F16: DrawableResource by lazy {
      DrawableResource("drawable:F16", setOf(
        ResourceItem(setOf(), "${MD}drawable/F16.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_338_408_857)
internal val Res.drawable.F17: DrawableResource by lazy {
      DrawableResource("drawable:F17", setOf(
        ResourceItem(setOf(), "${MD}drawable/F17.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_482_102_400)
internal val Res.drawable.F18: DrawableResource by lazy {
      DrawableResource("drawable:F18", setOf(
        ResourceItem(setOf(), "${MD}drawable/F18.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-289_942_157)
internal val Res.drawable.F19: DrawableResource by lazy {
      DrawableResource("drawable:F19", setOf(
        ResourceItem(setOf(), "${MD}drawable/F19.webp", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable2Resources(map: MutableMap<String, DrawableResource>) {
  map.put("D49", Res.drawable.D49)
  map.put("D5", Res.drawable.D5)
  map.put("D50", Res.drawable.D50)
  map.put("D50A", Res.drawable.D50A)
  map.put("D50B", Res.drawable.D50B)
  map.put("D50C", Res.drawable.D50C)
  map.put("D50D", Res.drawable.D50D)
  map.put("D50E", Res.drawable.D50E)
  map.put("D50F", Res.drawable.D50F)
  map.put("D50G", Res.drawable.D50G)
  map.put("D50H", Res.drawable.D50H)
  map.put("D50I", Res.drawable.D50I)
  map.put("D51", Res.drawable.D51)
  map.put("D52", Res.drawable.D52)
  map.put("D52A", Res.drawable.D52A)
  map.put("D53", Res.drawable.D53)
  map.put("D54", Res.drawable.D54)
  map.put("D54A", Res.drawable.D54A)
  map.put("D55", Res.drawable.D55)
  map.put("D56", Res.drawable.D56)
  map.put("D57", Res.drawable.D57)
  map.put("D58", Res.drawable.D58)
  map.put("D59", Res.drawable.D59)
  map.put("D6", Res.drawable.D6)
  map.put("D60", Res.drawable.D60)
  map.put("D61", Res.drawable.D61)
  map.put("D62", Res.drawable.D62)
  map.put("D63", Res.drawable.D63)
  map.put("D64", Res.drawable.D64)
  map.put("D65", Res.drawable.D65)
  map.put("D66", Res.drawable.D66)
  map.put("D67", Res.drawable.D67)
  map.put("D67A", Res.drawable.D67A)
  map.put("D67B", Res.drawable.D67B)
  map.put("D67C", Res.drawable.D67C)
  map.put("D67D", Res.drawable.D67D)
  map.put("D67E", Res.drawable.D67E)
  map.put("D67F", Res.drawable.D67F)
  map.put("D67G", Res.drawable.D67G)
  map.put("D67H", Res.drawable.D67H)
  map.put("D7", Res.drawable.D7)
  map.put("D8", Res.drawable.D8)
  map.put("D8A", Res.drawable.D8A)
  map.put("D9", Res.drawable.D9)
  map.put("E1", Res.drawable.E1)
  map.put("E10", Res.drawable.E10)
  map.put("E11", Res.drawable.E11)
  map.put("E12", Res.drawable.E12)
  map.put("E13", Res.drawable.E13)
  map.put("E14", Res.drawable.E14)
  map.put("E15", Res.drawable.E15)
  map.put("E16", Res.drawable.E16)
  map.put("E16A", Res.drawable.E16A)
  map.put("E17", Res.drawable.E17)
  map.put("E17A", Res.drawable.E17A)
  map.put("E18", Res.drawable.E18)
  map.put("E19", Res.drawable.E19)
  map.put("E2", Res.drawable.E2)
  map.put("E20", Res.drawable.E20)
  map.put("E20A", Res.drawable.E20A)
  map.put("E21", Res.drawable.E21)
  map.put("E22", Res.drawable.E22)
  map.put("E23", Res.drawable.E23)
  map.put("E24", Res.drawable.E24)
  map.put("E25", Res.drawable.E25)
  map.put("E26", Res.drawable.E26)
  map.put("E27", Res.drawable.E27)
  map.put("E28", Res.drawable.E28)
  map.put("E28A", Res.drawable.E28A)
  map.put("E29", Res.drawable.E29)
  map.put("E3", Res.drawable.E3)
  map.put("E30", Res.drawable.E30)
  map.put("E31", Res.drawable.E31)
  map.put("E32", Res.drawable.E32)
  map.put("E33", Res.drawable.E33)
  map.put("E34", Res.drawable.E34)
  map.put("E34A", Res.drawable.E34A)
  map.put("E36", Res.drawable.E36)
  map.put("E37", Res.drawable.E37)
  map.put("E38", Res.drawable.E38)
  map.put("E4", Res.drawable.E4)
  map.put("E5", Res.drawable.E5)
  map.put("E6", Res.drawable.E6)
  map.put("E7", Res.drawable.E7)
  map.put("E8", Res.drawable.E8)
  map.put("E8A", Res.drawable.E8A)
  map.put("E9", Res.drawable.E9)
  map.put("E9A", Res.drawable.E9A)
  map.put("F1", Res.drawable.F1)
  map.put("F10", Res.drawable.F10)
  map.put("F11", Res.drawable.F11)
  map.put("F12", Res.drawable.F12)
  map.put("F13", Res.drawable.F13)
  map.put("F13A", Res.drawable.F13A)
  map.put("F14", Res.drawable.F14)
  map.put("F15", Res.drawable.F15)
  map.put("F16", Res.drawable.F16)
  map.put("F17", Res.drawable.F17)
  map.put("F18", Res.drawable.F18)
  map.put("F19", Res.drawable.F19)
}
